import React from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

const BlogHeader = () => (
  <header className="blog-header">
    <Link to="/">← Back to site</Link>
    <Link to="/blog">Blog</Link>
    <Link to="/blog/map">Graph View</Link>
  </header>
);

export default BlogHeader;